module.exports = __webpack_public_path__ + "img/bmcl_gallery0.e770bf98.jpg";